module.exports = __webpack_public_path__ + "static/media/xayhk_lx.b4303b2e.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/xayhk_lx.png
// module id = 2180
// module chunks = 0